// Civil Construction Materials Database
// For paving, drainage, utilities, and infrastructure projects

// CONCRETE & PAVING MATERIALS
export const concretePavingDatabase = [
  // === CONCRETE ===
  {
    name: 'Standard Concrete (3000 PSI)',
    category: 'Concrete',
    weightPerCubicYard: 4050,
    costPerYard: 125,
    description: 'General purpose concrete for sidewalks and slabs'
  },
  {
    name: 'High Strength Concrete (4000 PSI)',
    category: 'Concrete',
    weightPerCubicYard: 4100,
    costPerYard: 140,
    description: 'Higher strength for driveways and light traffic'
  },
  {
    name: 'Heavy Duty Concrete (5000 PSI)',
    category: 'Concrete',
    weightPerCubicYard: 4150,
    costPerYard: 160,
    description: 'Commercial/industrial applications'
  },
  {
    name: 'Fiber Reinforced Concrete',
    category: 'Concrete',
    weightPerCubicYard: 4100,
    costPerYard: 175,
    description: 'With fiber reinforcement for crack resistance'
  },
  {
    name: 'Flowable Fill (CLSM)',
    category: 'Concrete',
    weightPerCubicYard: 2200,
    costPerYard: 95,
    description: 'Controlled low-strength material for backfill'
  },
  // === ASPHALT ===
  {
    name: 'Hot Mix Asphalt (HMA) Base',
    category: 'Asphalt',
    tonsPerCubicYard: 1.95,
    costPerTon: 95,
    description: 'Base course asphalt paving'
  },
  {
    name: 'Hot Mix Asphalt (HMA) Surface',
    category: 'Asphalt',
    tonsPerCubicYard: 2.0,
    costPerTon: 110,
    description: 'Surface/wearing course asphalt'
  },
  {
    name: 'Warm Mix Asphalt (WMA)',
    category: 'Asphalt',
    tonsPerCubicYard: 1.95,
    costPerTon: 105,
    description: 'Lower temperature asphalt mix'
  },
  {
    name: 'Recycled Asphalt Pavement (RAP)',
    category: 'Asphalt',
    tonsPerCubicYard: 1.85,
    costPerTon: 65,
    description: 'Recycled asphalt for base or mix'
  },
  {
    name: 'Cold Patch Asphalt',
    category: 'Asphalt',
    tonsPerCubicYard: 1.8,
    costPerTon: 85,
    description: 'For repairs and small patches'
  },
  // === CURB & GUTTER ===
  {
    name: 'Standard Curb & Gutter (18")',
    category: 'Curb & Gutter',
    cubicYardsPerLinearFt: 0.056,
    costPerLinearFt: 28,
    description: 'Standard 18-inch combined curb and gutter'
  },
  {
    name: 'Rolled Curb & Gutter',
    category: 'Curb & Gutter',
    cubicYardsPerLinearFt: 0.048,
    costPerLinearFt: 24,
    description: 'Mountable rolled curb and gutter'
  },
  {
    name: 'Barrier Curb (24")',
    category: 'Curb & Gutter',
    cubicYardsPerLinearFt: 0.065,
    costPerLinearFt: 32,
    description: 'Non-mountable barrier curb'
  },
  {
    name: 'Vertical Curb Only (6")',
    category: 'Curb & Gutter',
    cubicYardsPerLinearFt: 0.022,
    costPerLinearFt: 15,
    description: 'Vertical curb without gutter'
  }
];

// DRAINAGE MATERIALS
export const drainageDatabase = [
  // === STORM DRAIN PIPE ===
  {
    name: '12" HDPE Storm Pipe',
    category: 'Storm Pipe',
    diameter: 12,
    weightPerLinearFt: 4.5,
    costPerLinearFt: 18,
    description: 'High-density polyethylene storm drain'
  },
  {
    name: '15" HDPE Storm Pipe',
    category: 'Storm Pipe',
    diameter: 15,
    weightPerLinearFt: 6.2,
    costPerLinearFt: 24,
    description: 'Medium diameter HDPE storm drain'
  },
  {
    name: '18" HDPE Storm Pipe',
    category: 'Storm Pipe',
    diameter: 18,
    weightPerLinearFt: 8.5,
    costPerLinearFt: 32,
    description: '18-inch HDPE storm drain pipe'
  },
  {
    name: '24" HDPE Storm Pipe',
    category: 'Storm Pipe',
    diameter: 24,
    weightPerLinearFt: 12.8,
    costPerLinearFt: 48,
    description: 'Large diameter HDPE storm drain'
  },
  {
    name: '36" HDPE Storm Pipe',
    category: 'Storm Pipe',
    diameter: 36,
    weightPerLinearFt: 24.5,
    costPerLinearFt: 85,
    description: 'Extra large HDPE storm drain'
  },
  {
    name: '18" RCP (Reinforced Concrete)',
    category: 'Storm Pipe',
    diameter: 18,
    weightPerLinearFt: 95,
    costPerLinearFt: 45,
    description: 'Reinforced concrete pipe'
  },
  {
    name: '24" RCP (Reinforced Concrete)',
    category: 'Storm Pipe',
    diameter: 24,
    weightPerLinearFt: 145,
    costPerLinearFt: 65,
    description: '24-inch reinforced concrete pipe'
  },
  {
    name: '36" RCP (Reinforced Concrete)',
    category: 'Storm Pipe',
    diameter: 36,
    weightPerLinearFt: 285,
    costPerLinearFt: 110,
    description: 'Large RCP for major drainage'
  },
  {
    name: '48" RCP (Reinforced Concrete)',
    category: 'Storm Pipe',
    diameter: 48,
    weightPerLinearFt: 450,
    costPerLinearFt: 165,
    description: 'Extra large RCP for trunk lines'
  },
  // === DRAINAGE STRUCTURES ===
  {
    name: 'Standard Catch Basin (2x2)',
    category: 'Drainage Structures',
    unitCost: 1800,
    weight: 1500,
    description: 'Standard 2x2 feet catch basin with grate'
  },
  {
    name: 'Large Catch Basin (3x3)',
    category: 'Drainage Structures',
    unitCost: 2800,
    weight: 2400,
    description: 'Large 3x3 feet catch basin'
  },
  {
    name: 'Curb Inlet',
    category: 'Drainage Structures',
    unitCost: 2200,
    weight: 1800,
    description: 'Curb opening inlet structure'
  },
  {
    name: 'Area Drain',
    category: 'Drainage Structures',
    unitCost: 650,
    weight: 85,
    description: 'Surface area drain with grate'
  },
  {
    name: 'Trench Drain (per LF)',
    category: 'Drainage Structures',
    costPerLinearFt: 125,
    weightPerLinearFt: 45,
    description: 'Channel drain with grate'
  },
  {
    name: '4\' Diameter Manhole',
    category: 'Drainage Structures',
    unitCost: 4500,
    weight: 8500,
    description: '4-foot diameter precast manhole'
  },
  {
    name: '5\' Diameter Manhole',
    category: 'Drainage Structures',
    unitCost: 5800,
    weight: 12000,
    description: '5-foot diameter precast manhole'
  },
  // === CULVERTS ===
  {
    name: '18" CMP Culvert',
    category: 'Culverts',
    diameter: 18,
    weightPerLinearFt: 18,
    costPerLinearFt: 35,
    description: 'Corrugated metal pipe culvert'
  },
  {
    name: '24" CMP Culvert',
    category: 'Culverts',
    diameter: 24,
    weightPerLinearFt: 26,
    costPerLinearFt: 48,
    description: '24-inch corrugated metal culvert'
  },
  {
    name: '36" CMP Culvert',
    category: 'Culverts',
    diameter: 36,
    weightPerLinearFt: 42,
    costPerLinearFt: 75,
    description: 'Large corrugated metal culvert'
  },
  {
    name: '48" CMP Culvert',
    category: 'Culverts',
    diameter: 48,
    weightPerLinearFt: 65,
    costPerLinearFt: 110,
    description: 'Extra large CMP culvert'
  },
  {
    name: 'Box Culvert (4x4)',
    category: 'Culverts',
    unitCostPerLinearFt: 450,
    weightPerLinearFt: 850,
    description: 'Precast concrete box culvert'
  },
  {
    name: 'Box Culvert (6x6)',
    category: 'Culverts',
    unitCostPerLinearFt: 750,
    weightPerLinearFt: 1450,
    description: 'Large precast box culvert'
  }
];

// UTILITY MATERIALS
export const utilityDatabase = [
  // === WATER LINES ===
  {
    name: '4" Ductile Iron Water Main',
    category: 'Water Lines',
    diameter: 4,
    weightPerLinearFt: 11.5,
    costPerLinearFt: 28,
    description: 'Ductile iron water distribution'
  },
  {
    name: '6" Ductile Iron Water Main',
    category: 'Water Lines',
    diameter: 6,
    weightPerLinearFt: 18.5,
    costPerLinearFt: 38,
    description: '6-inch ductile iron water main'
  },
  {
    name: '8" Ductile Iron Water Main',
    category: 'Water Lines',
    diameter: 8,
    weightPerLinearFt: 27.5,
    costPerLinearFt: 52,
    description: '8-inch ductile iron water main'
  },
  {
    name: '12" Ductile Iron Water Main',
    category: 'Water Lines',
    diameter: 12,
    weightPerLinearFt: 51,
    costPerLinearFt: 85,
    description: 'Large ductile iron transmission main'
  },
  {
    name: '6" PVC Water Main (C900)',
    category: 'Water Lines',
    diameter: 6,
    weightPerLinearFt: 3.2,
    costPerLinearFt: 22,
    description: 'PVC water main - lighter and cheaper'
  },
  {
    name: '8" PVC Water Main (C900)',
    category: 'Water Lines',
    diameter: 8,
    weightPerLinearFt: 4.8,
    costPerLinearFt: 32,
    description: '8-inch PVC water main'
  },
  // === SEWER LINES ===
  {
    name: '8" PVC Sewer Pipe (SDR 35)',
    category: 'Sewer Lines',
    diameter: 8,
    weightPerLinearFt: 3.5,
    costPerLinearFt: 18,
    description: 'PVC gravity sewer pipe'
  },
  {
    name: '10" PVC Sewer Pipe (SDR 35)',
    category: 'Sewer Lines',
    diameter: 10,
    weightPerLinearFt: 5.2,
    costPerLinearFt: 24,
    description: '10-inch PVC sewer main'
  },
  {
    name: '12" PVC Sewer Pipe (SDR 35)',
    category: 'Sewer Lines',
    diameter: 12,
    weightPerLinearFt: 7.5,
    costPerLinearFt: 32,
    description: '12-inch PVC sewer main'
  },
  {
    name: '15" PVC Sewer Pipe',
    category: 'Sewer Lines',
    diameter: 15,
    weightPerLinearFt: 11,
    costPerLinearFt: 45,
    description: 'Large PVC sewer main'
  },
  {
    name: '8" Ductile Iron Sewer (Force Main)',
    category: 'Sewer Lines',
    diameter: 8,
    weightPerLinearFt: 27.5,
    costPerLinearFt: 58,
    description: 'Pressure rated sewer force main'
  },
  // === GAS LINES ===
  {
    name: '2" PE Gas Line',
    category: 'Gas Lines',
    diameter: 2,
    weightPerLinearFt: 0.5,
    costPerLinearFt: 8,
    description: 'Polyethylene gas distribution'
  },
  {
    name: '4" PE Gas Line',
    category: 'Gas Lines',
    diameter: 4,
    weightPerLinearFt: 1.2,
    costPerLinearFt: 15,
    description: '4-inch PE gas main'
  },
  {
    name: '6" Steel Gas Main',
    category: 'Gas Lines',
    diameter: 6,
    weightPerLinearFt: 19,
    costPerLinearFt: 65,
    description: 'Coated steel gas transmission'
  },
  // === ELECTRICAL ===
  {
    name: '2" PVC Electrical Conduit',
    category: 'Electrical',
    diameter: 2,
    weightPerLinearFt: 0.8,
    costPerLinearFt: 5,
    description: 'PVC electrical conduit'
  },
  {
    name: '4" PVC Electrical Conduit',
    category: 'Electrical',
    diameter: 4,
    weightPerLinearFt: 2.2,
    costPerLinearFt: 12,
    description: 'Large PVC conduit for feeders'
  },
  {
    name: '6" PVC Duct Bank',
    category: 'Electrical',
    diameter: 6,
    weightPerLinearFt: 4.5,
    costPerLinearFt: 22,
    description: 'PVC duct for underground electric'
  },
  {
    name: 'Concrete Encased Duct Bank (per LF)',
    category: 'Electrical',
    costPerLinearFt: 85,
    weightPerLinearFt: 125,
    description: 'Concrete encased conduit bank'
  }
];

// ROAD & PAVING SPECIFICATIONS
export const roadSpecifications = [
  {
    name: 'Light Duty Parking Lot',
    category: 'Parking Lots',
    layers: [
      { name: 'Subgrade Prep', depth: 6, unit: 'inch' },
      { name: 'Aggregate Base', depth: 6, unit: 'inch', tonsPerSY: 0.055 },
      { name: 'Asphalt', depth: 2, unit: 'inch', tonsPerSY: 0.11 }
    ],
    costPerSqYd: 35,
    description: 'For cars only - light traffic'
  },
  {
    name: 'Standard Parking Lot',
    category: 'Parking Lots',
    layers: [
      { name: 'Subgrade Prep', depth: 8, unit: 'inch' },
      { name: 'Aggregate Base', depth: 8, unit: 'inch', tonsPerSY: 0.073 },
      { name: 'Asphalt Base', depth: 2, unit: 'inch', tonsPerSY: 0.11 },
      { name: 'Asphalt Surface', depth: 1.5, unit: 'inch', tonsPerSY: 0.083 }
    ],
    costPerSqYd: 52,
    description: 'Standard commercial parking'
  },
  {
    name: 'Heavy Duty Industrial',
    category: 'Parking Lots',
    layers: [
      { name: 'Subgrade Prep', depth: 12, unit: 'inch' },
      { name: 'Aggregate Base', depth: 12, unit: 'inch', tonsPerSY: 0.11 },
      { name: 'Asphalt Base', depth: 3, unit: 'inch', tonsPerSY: 0.165 },
      { name: 'Asphalt Surface', depth: 2, unit: 'inch', tonsPerSY: 0.11 }
    ],
    costPerSqYd: 85,
    description: 'For trucks and heavy equipment'
  },
  {
    name: 'Residential Street',
    category: 'Roads',
    layers: [
      { name: 'Subgrade Prep', depth: 8, unit: 'inch' },
      { name: 'Aggregate Base', depth: 8, unit: 'inch', tonsPerSY: 0.073 },
      { name: 'Asphalt', depth: 3, unit: 'inch', tonsPerSY: 0.165 }
    ],
    costPerSqYd: 48,
    description: 'Low volume residential road'
  },
  {
    name: 'Collector Road',
    category: 'Roads',
    layers: [
      { name: 'Subgrade Prep', depth: 12, unit: 'inch' },
      { name: 'Aggregate Base', depth: 10, unit: 'inch', tonsPerSY: 0.092 },
      { name: 'Asphalt Base', depth: 3, unit: 'inch', tonsPerSY: 0.165 },
      { name: 'Asphalt Surface', depth: 2, unit: 'inch', tonsPerSY: 0.11 }
    ],
    costPerSqYd: 72,
    description: 'Medium volume collector road'
  },
  {
    name: 'Arterial Road',
    category: 'Roads',
    layers: [
      { name: 'Subgrade Stabilization', depth: 12, unit: 'inch' },
      { name: 'Aggregate Base', depth: 12, unit: 'inch', tonsPerSY: 0.11 },
      { name: 'Asphalt Binder', depth: 4, unit: 'inch', tonsPerSY: 0.22 },
      { name: 'Asphalt Surface', depth: 2, unit: 'inch', tonsPerSY: 0.11 }
    ],
    costPerSqYd: 95,
    description: 'High volume arterial road'
  },
  {
    name: 'Concrete Pavement (8")',
    category: 'Concrete Roads',
    layers: [
      { name: 'Subgrade Prep', depth: 6, unit: 'inch' },
      { name: 'Aggregate Base', depth: 4, unit: 'inch', tonsPerSY: 0.037 },
      { name: 'Concrete', depth: 8, unit: 'inch', cubicYardsPerSY: 0.222 }
    ],
    costPerSqYd: 85,
    description: 'Standard concrete roadway'
  }
];

// GRADING SPECIFICATIONS
export const gradingDatabase = [
  {
    name: 'Rough Grading',
    category: 'Site Grading',
    costPerCubicYard: 4.50,
    description: 'Initial site grading, cut and fill'
  },
  {
    name: 'Fine Grading',
    category: 'Site Grading',
    costPerSquareYard: 2.25,
    description: 'Final grade to specifications'
  },
  {
    name: 'Subgrade Preparation',
    category: 'Site Grading',
    costPerSquareYard: 3.50,
    description: 'Prepare subgrade for paving'
  },
  {
    name: 'Proof Rolling',
    category: 'Site Grading',
    costPerSquareYard: 0.85,
    description: 'Proof roll compaction test'
  },
  {
    name: 'Soil Compaction (95%)',
    category: 'Compaction',
    costPerCubicYard: 2.50,
    description: 'Compact to 95% modified proctor'
  },
  {
    name: 'Soil Compaction (98%)',
    category: 'Compaction',
    costPerCubicYard: 3.50,
    description: 'Compact to 98% - structural fills'
  },
  {
    name: 'Rock Excavation',
    category: 'Excavation',
    costPerCubicYard: 35,
    description: 'Ripping or blasting rock'
  },
  {
    name: 'Unclassified Excavation',
    category: 'Excavation',
    costPerCubicYard: 8,
    description: 'General excavation any material'
  },
  {
    name: 'Select Fill Import',
    category: 'Fill',
    costPerCubicYard: 18,
    tonsPerCubicYard: 1.4,
    description: 'Import and place select fill'
  },
  {
    name: 'Structural Fill',
    category: 'Fill',
    costPerCubicYard: 25,
    tonsPerCubicYard: 1.5,
    description: 'Import structural fill material'
  }
];
